import { STALE_TIME, GC_TIME, QUERY_PRESETS } from "@/queries/queryTimeConfig";

export const bedTypeConfig = {
  getBedTypes: {
    key: "getBedTypes",
    url: "/api/v1/master-data/bedtype",
    method: "GET",
    options: {
      staleTime: STALE_TIME.LONG,
      gcTime: GC_TIME.STATIC,
      refetchOnWindowFocus: false,
      keepPreviousData: true,
    },
  },
  getRoomCategories: {
    key: "getRoomCategories",
    url: "/api/v1/master-data/roomcategory",
    method: "GET",
    options: {
      staleTime: STALE_TIME.LONG,
      gcTime: GC_TIME.STATIC,
      refetchOnWindowFocus: false,
      keepPreviousData: true,
    },
  },
  getRoomViewTypes: {
    key: "getRoomViewTypes",
    url: "/api/v1/master-data/roomviewtype",
    method: "GET",
    options: {
      staleTime: STALE_TIME.LONG,
      gcTime: GC_TIME.STATIC,
      refetchOnWindowFocus: false,
      keepPreviousData: true,
    },
  },
  getRoomAmenities: {
    key: "getRoomAmenities",
    url: "/api/v1/master-data/roomamenity",
    method: "GET",
    options: {
      staleTime: STALE_TIME.LONG,
      gcTime: GC_TIME.STATIC,
      refetchOnWindowFocus: false,
      keepPreviousData: true,
    },
  },
};
